export default __webpack_public_path__ + "static/media/singleCard_disabled.4aef98b5.svg";